export const dealerServicerRowOptions = [
  { label: 'Edit', value: 'Edit', callback: 'onRowEdit' },
  { label: 'Remove', value: 'Remove', callback: 'onClickDelete' }
];

export const dealerServicerHeaderOptions = [{ label: 'Add', value: 'Add', callback: 'onClickAdd' }];
